import { render, staticRenderFns } from "./PageMessageThreads.vue?vue&type=template&id=5e48de6c&"
import script from "./PageMessageThreads.vue?vue&type=script&lang=ts&"
export * from "./PageMessageThreads.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports